import { Injectable, OnDestroy } from '@angular/core';
import { EmitterService } from '../services/emitter.service';
import { AppDetailsService } from '../services/app-details.services';
import { UserDetailsService } from '../services/user-details.service';
import { Utility } from '../shared/utility/utility';
import { CountryDataService } from '../services/country.service';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";


import * as _ from 'underscore';
@Injectable()
export class LiveGamesService implements OnDestroy {

  websocket = null;
  wsUri = null;
  tableId = null;
  casinoId = null;
  tryToConnect = true;
  liveTableIds;
  liveTableData = {};
  tableKeys;
  currency;
  currencyCode;
  statusCall;
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private emitterService:EmitterService,
    private appDetails: AppDetailsService,
    private utils: Utility,
    private userService: UserDetailsService,
    private countryDataService: CountryDataService
  ) {

    this.emitterService.liveCasinoTableIds$.pipe(takeUntil(this.destroy$)).subscribe(tableIds => {
      this.liveTableIds = tableIds;
    });

    this.emitterService.liveCasinoTableData$.pipe(takeUntil(this.destroy$)).subscribe(tabledata => {
      if(tabledata && !_.isEmpty(tabledata) && !tabledata["error"]){
          this.liveTableData[tabledata["tableId"]] = tabledata;
      }
    });

    this.appDetails.currency$.pipe(takeUntil(this.destroy$)).subscribe((currency)=>{
      this.setLiveGamesCurrency(this.countryDataService.IPCountry);
    });

    this.userService.userCountryUpdated$.pipe(takeUntil(this.destroy$)).subscribe(country => {
      this.setLiveGamesCurrency(this.countryDataService.IPCountry);
    });

    this.emitterService.statusCall$.pipe(takeUntil(this.destroy$)).subscribe(statusCall =>{
      this.statusCall = true;
      this.setLiveGamesCurrency(this.countryDataService.IPCountry);
    });

  }

  setLiveGamesCurrency(country){
    let userLogin = this.utils.isUserLoggedIn();
    if(userLogin && this.userService.getUserCurrencySymbol()){
      this.currency = this.userService.getUserCurrencySymbol();
      this.currencyCode = this.userService.getUserCurrencyCode()
    } else if (!userLogin && this.countryDataService.IPCountry){
      switch(country){
        case "SE":
        this.currency = "kr";
        this.currencyCode = "SEK";
        break;
        case "NO":
        this.currency = "kr";
        this.currencyCode = "NOK";
        break;
        case "CA":
        case "NZ":
        this.currency = "&#36;";
        this.currencyCode = "USD";
        break;
        case "CH":
        this.currency = "&#8355;";
        this.currencyCode = "CHF";
        break;
        default:
        this.currency = "&#128;";
        this.currencyCode = "EUR";
        break;
      }
    }
    if(this.currencyCode && this.statusCall && this.tableKeys){
      this.statusCall = false;
      this.subscribeToTable(this.currencyCode)
    }
    
  }

  subscribeToTable(currencyCode){
    let tableKeys = this.tableKeys;
    for ( let key in tableKeys) {
      this.subscribe(this.casinoId, tableKeys[key], currencyCode);
    }
  }

  getLiveTableData(){
    return this.liveTableData;
  }


  connect(wsUri, casinoId?, tableId?) {
    this.tryToConnect = true;
    this.statusCall = true;
    this.wsUri = wsUri;
    this.websocket = new WebSocket('wss://' + wsUri + '/ws');
    this.websocket.onopen = evt => {
      this.onWsOpen(evt);
    };
    this.websocket.onclose = evt => {
      this.onWsClose(evt);
    };
    this.websocket.onmessage = evt => {
      this.onWsMessage(evt);
    };
    this.websocket.onerror = evt => {
      this.onWsError(evt);
    };
    if (tableId) {
      this.tableId = tableId;
    }
    this.casinoId = casinoId;
  }

  onMessage(data) {
    if (data) {
      if (data.tableKey) {
        this.emitterService.broadcastLiveCasinoTableIds(data.tableKey);
        this.tableKeys = data.tableKey;
        this.setLiveGamesCurrency(this.countryDataService.IPCountry);
      } else {
        if(data && !_.isEmpty(data)){
          data["currency"] = this.currency;
          data["currencyCode"] = this.currencyCode;
        }
        this.emitterService.broadcastLiveCasinoTableData(data);
      }
    }
  }

  onConnect() {
    this.available(this.casinoId);
  }

  disconnect() {
    this.tryToConnect = false;
    this.websocket.close();
  }

  subscribe(casinoId, tableId, currency?) {
    let subscribeMessage = {
      type : 'subscribe',
      key : tableId,
      casinoId : casinoId,
      currency : currency
    }
    let jsonSub = JSON.stringify(subscribeMessage);
    this.doWsSend(jsonSub);
  }


  available(casinoId) {
    let subscribeMessage = {
      type : 'available',
      casinoId : casinoId
    }
    let jsonSub = JSON.stringify(subscribeMessage);
    this.doWsSend(jsonSub);
  }

  onWsOpen(evt) {
    if (this.onConnect) {
      this.onConnect();
    }
    
    if (this.tableId) {
      this.subscribe(this.casinoId, this.tableId)
    }
  }

  onWsClose(evt) {
    if (this.tryToConnect === true) {
      this.connect(this.wsUri, this.casinoId, this.tableId);
    }
  }

  onWsMessage(evt) {
    let data = JSON.parse(evt.data);
    if (this.onMessage) {
      this.onMessage(data);
    }
  }

  onWsError(evt) {}

  doWsSend(message) {
    this.websocket.send(message);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
